<script>
	const { assetUrl } = require('utilities/urlUtilities');

	module.exports = {
		props: {
			text: {
				default: 'Loading...'
			}
		},
		computed: {
			loaderImageSrc() {
				return assetUrl('/assets/dist/images/loader.gif');
			}
		}
	};
</script>
<style lang="scss">
	.loading-container {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: rgba(255, 255, 255, 0.6);
		z-index: 5;

		.loading-plaque {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0.5rem;
			border-radius: 4px;
			background-color: white;

			.loading-indicator {
				display: inline-block;
				margin-right: 0.5rem;
			}
		}
		&.align-top {
			align-items: start;
			.loading-plaque {
				margin-top: 2rem;
			}
		}
	}
</style>
<template>
	<div
		class="loading-container"
		role="status">
		<span class="loading-plaque">
			<img
				:src="loaderImageSrc"
				class="loading-indicator"
				alt="Loading" />
			{{ text }}
		</span>
	</div>
</template>
